import { createSlice } from '@reduxjs/toolkit'

export const postsSlice = createSlice({
    name: 'posts',
    initialState: {
        items: [],
        avatarErrors: {},
        lastSync: 0,
    },
    reducers: {
        setPosts: (state, action) => {
            state.items = action.payload;
        },
        appendPosts: (state, action) => {
            state.items = state.items.concat(action.payload).sort((a, b) => b.timestamp - a.timestamp);
        },
        setLastSync: (state, action) => {
            state.lastSync = action.payload.lastSync
        },
        insertPost: (state, action) => {
            state.items = [action.payload.post, ...state.items]
        },
        updateLikeCounter: (state, action) => {
            const existingPostIndex = state.items?.findIndex((e) => e.id === action.payload.postId)
            if (existingPostIndex !== -1) {
                const currentLikes = state.items[existingPostIndex].likes || 0

                if (action.payload.like) {
                    state.items[existingPostIndex].likes = currentLikes + 1
                } else {
                    state.items[existingPostIndex].likes = Math.max(0, currentLikes - 1)
                }
            }
        },
        setAvatarError: (state, action) => {
            state.avatarErrors[action.payload.author] = true
        },
        updateCommentsCounter: (state, action) => {
            const existingPostIndex = state.items?.findIndex((e) => e.id === action.payload.postId)
            if (existingPostIndex !== -1) {
                const currentComments = state.items[existingPostIndex].comments || 0
                if (action.payload.change) {
                    state.items[existingPostIndex].comments = currentComments + action.payload.change
                }
            }
        },
        deletePost: (state, action) => {
            state.items = state.items?.filter((item) => item.id !== action.payload.postId)
        },
        updatePost: (state, action) => {
            const existingPostIndex = state.items?.findIndex((e) => e.id === action.payload.postId)
            if (existingPostIndex !== -1) {
                state.items[existingPostIndex].content = action.payload.content
                state.items[existingPostIndex].modified = Date.now()
            }
        },
        forgetPosts: (state, action) => {
            state.items = []
        }


    },

});
export const { setPosts, setLastSync, appendPosts, insertPost, updateLikeCounter, updateCommentsCounter, setAvatarError, deletePost, updatePost, forgetPosts } = postsSlice.actions
export default postsSlice.reducer;